import clsx from 'clsx'
import { useEffect } from 'preact/hooks'
import { useSwatchImage } from 'libs/searchspring/hooks/useSwatchImage'

function getLowQualityPlaceholder(imageUrl) {
  if (!imageUrl) return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUCB1j+Pjx438ACX0D04PrXz0AAAAASUVORK5CYII='
  return `${imageUrl}&width=5`
}

export function ResultsSwatches({ result, swatches, onSelectSwatch }) {
  if (!swatches || swatches.length === 0) return null

  return (
    <>
      <div className="hidden lg:flex gap-x-0.5 w-[calc(100%+1rem)] lg:w-[calc(100%+1.5rem)] -ml-1 lg:-ml-1.5 pl-1 lg:pl-1.5 overflow-x-scroll no-scrollbar overscroll-none">
        {swatches.map((swatch) => {
          return (
            <Swatch
              key={swatch.handle}
              swatch={swatch}
              onSelectSwatch={onSelectSwatch}
              isCurrentSwatch={swatch.handle === result.handle}
            />
          )
        })}
      </div>
    </>
  )
}

function Swatch({ swatch, onSelectSwatch, isCurrentSwatch }) {
  function handleClick() {
    onSelectSwatch(swatch.handle)
  }

  const { imageUrl, isLoading } = useSwatchImage(swatch.handle)

  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [imageUrl])

  if (!isLoading && !imageUrl) {
    return null
  }

  return (
    <button
      className={clsx('shrink-0 flex size-[52px] border-b transition-all', isCurrentSwatch ? 'border-brand-black' : 'border-transparent hover:border-neutral-medium')}
      onClick={handleClick}
      aria-label="View product"
      data-dl-track="toggle_variant"
      data-dl-product-id={swatch.productLegacyResourceId}
      data-dl-attribute="item_colour"
      data-dl-value={swatch.colourName}
    >
      {imageUrl && (
        <img
          className="lazy size-full object-cover"
          src={getLowQualityPlaceholder(imageUrl)}
          data-src={imageUrl}
          alt={swatch.colourName || 'Product swatch'}
        />
      )}
    </button>
  )
}
